import { Icon } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { AddFilterTrigger } from '../styles'

interface ReviewEntriesResetFiltersButtonProps {
  onClick: () => void
}

export const ReviewEntriesResetFiltersButton = ({ onClick }: ReviewEntriesResetFiltersButtonProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <AddFilterTrigger onClick={onClick} type="button">
      <Icon color="currentColor" icon="refresh" size="sm" />
      {t('review_entries.filters.action.reset_all')}
    </AddFilterTrigger>
  )
}
